import MapImage from "../assets/img/map.png";

export interface MapProps {
  city: string;
  street: string;
  postalCode: string;
  dealer: string;
}

export function Map({ city, street, postalCode, dealer }: MapProps) {
  // Format the address
  let address = dealer;
  if (city !== null) {
    address = `${street}, ${city}, ${postalCode}`;
  }
  if (dealer.toUpperCase() === "BAOTIĆ AUTODUBRAVA D.O.O.") {
    address = "Maksimirska Cesta 282, 10000, Zagreb";
  }

  // Generate src URL
  const mapSrc = `https://www.google.com/maps/embed/v1/place?key=${
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  }&q=${encodeURIComponent(address)}`;

  return (
    <div className="w-full h-full">
      {process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? (
        <iframe
          src={mapSrc}
          title={`Mapa lokacije: ${address}`}
          className="w-full h-full"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      ) : (
        <img
          className="object-cover w-full h-full"
          src={MapImage}
          alt="Google map"
        ></img>
      )}
    </div>
  );
}

export default Map;
